module.exports = {
    GA_LABEL_ANDROID_APP_DOWNLOAD_BUTTON_CLICK: 'apps-post-android-button' ,
    GA_LABEL_ANDROID_APP_DOWNLOAD_ICON_CLICK: 'apps-post-android-icon',
    GA_LABEL_IOS_APP_DOWNLOAD_BUTTON_CLICK: 'apps-post-ios-button',
    GA_LABEL_IOS_APP_DOWNLOAD_ICON_CLICK: 'apps-post-ios-icon',

    ANDROID_APP_DOWNLOAD_HREF: 'https://app.adjust.com/ctdbr5',
    IOS_APP_DOWNLOAD_HREF: 'https://app.adjust.com/euljld',
    INSTAGRAM_API_OEMBED_URL: 'https://api.instagram.com/oembed',
    
    FACEBOOK_APP_ID: "112848376993",
    FACEBOOK_VERSION: "v2.12",
    FB_FEED_URL: "url"
}
